/* eslint-disable react/destructuring-assignment */
import { TILE_LIMIT, TILE_TYPE } from '../../core/Constants';
import {
  prioritizedListNotifications as welcomeCardPrioritizedListNotifications,
  showingTileNotifications as welcomeCardShowingTileNotifications,
} from '../../components/LoyaltyWelcomeCard/NotificationSection/NotificationSection';
import { PrioritizeTabletList as welcomeCardPrioritizeTabletList } from
'../../components/LoyaltyWelcomeCard/NotificationSection/Notifications/TabletTiles';
import {
  prioritizedListPromotions as welcomeCardPrioritizedListPromotions,
  showingTilePromotions as welcomeCardShowingTilePromotions,
} from '../../components/LoyaltyWelcomeCard/PromotionSection/PromotionSection';
import {
  prioritizedListNotifications as offersCardPrioritizedListNotifications,
  showingTileNotifications as offersCardShowingTileNotifications,
} from '../../components/OffersCard/OffersNotificationSection/NotificationSection';
import { PrioritizeTabletList as offersCardPrioritizeTabletList } from
'../../components/OffersCard/OffersNotificationSection/Notifications/TabletTiles';
import {
  prioritizedListPromotions as offersCardPrioritizedListPromotions,
  showingTilePromotions as offersCardShowingTilePromotions,
} from '../../components/OffersCard/OffersPromotionSection/PromotionSection';

// Each component owns its own tile-building implementation; select the matching set here.
const TILE_BUILDERS = {
  LoyaltyWelcomeCard: {
    showingTileNotifications: welcomeCardShowingTileNotifications,
    prioritizedListNotifications: welcomeCardPrioritizedListNotifications,
    showingTilePromotions: welcomeCardShowingTilePromotions,
    prioritizedListPromotions: welcomeCardPrioritizedListPromotions,
    PrioritizeTabletList: welcomeCardPrioritizeTabletList,
  },
  OffersCard: {
    showingTileNotifications: offersCardShowingTileNotifications,
    prioritizedListNotifications: offersCardPrioritizedListNotifications,
    showingTilePromotions: offersCardShowingTilePromotions,
    prioritizedListPromotions: offersCardPrioritizedListPromotions,
    PrioritizeTabletList: offersCardPrioritizeTabletList,
  },
};

export const createTiles = ({
  isAdmin,
  userData,
  availablePerksData,
  isLoadingPerks,
  refreshAvailablePerks,
  refreshAvailableOffers,
  availablePerksError,
  showSweepstakesTile,
  sweepstakesData,
  channel,
  componentName = 'LoyaltyWelcomeCard',
}) => {
  const {
    showingTileNotifications,
    prioritizedListNotifications,
    showingTilePromotions,
    prioritizedListPromotions,
    PrioritizeTabletList,
  } = TILE_BUILDERS[componentName] || TILE_BUILDERS.LoyaltyWelcomeCard;

  const isMobile = channel === 'mobile';
  const showingTile = {
    NOTIFICATION: showingTileNotifications({ isAdmin, userData, availablePerksData }),
    PROMOTION: showingTilePromotions({ isAdmin, userData }),
  };
  const prioritizedList = {
    NOTIFICATION: prioritizedListNotifications({
      showingTile: showingTile.NOTIFICATION,
      userData,
      availablePerksData,
      isLoadingPerks,
      refreshAvailablePerks,
      refreshAvailableOffers,
      availablePerksError,
      isAdmin,
      showSweepstakesTile,
      sweepstakesData,
    }),
    PROMOTION: prioritizedListPromotions({
      showingTile: showingTile.PROMOTION,
      userData,
      isMobile
    }),
  };
  const prioritizedTabletList = isAdmin
    ? PrioritizeTabletList(prioritizedList.NOTIFICATION, availablePerksData, isLoadingPerks)
    : PrioritizeTabletList(prioritizedList.PROMOTION, availablePerksData, isLoadingPerks);

  // Return arrays of React elements, not rendered JSX
  const filteredNotifications = prioritizedList.NOTIFICATION.filter(Boolean);
  const filteredPromotions = prioritizedList.PROMOTION.filter(Boolean);
  const filteredTablet = prioritizedTabletList.filter(Boolean);

  return {
    NOTIFICATION: filteredNotifications.slice(0, TILE_LIMIT),
    PROMOTION: filteredPromotions.slice(0, isMobile ? 2 : 4),
    TABLET: filteredTablet.slice(0, 3),
  };
};
